export { FieldScrapAttrition } from './FieldScrapAttrition';
